module.exports = __webpack_public_path__ + "img/Butterfly_00014.48c9dc80.png";